<template>
	<DatePicker type="daterange" v-model="date" :placeholder="placeholder" :editable="editable" :clearable="true" class="resetable" :transfer="transfer"></DatePicker>
</template>

<script>
/**
 * DatePicker中的ab便捷用法
 * <ab-date-range :start.sync="startTime" :end.sync="endTime"></ab-date-range>
 */
 import Vue from 'vue'
export default {
 	name: 'abDataRange',
	props: {
		start : {
			required: true
		},
		end : {
			required: true
		},
		editable : {
			default : false
		},
		placeholder : {
			default : "请选择时间范围"
		},
		transfer : {
			default : false
		}
	},
  	data :function () {
	    return {
	    	date:[],
	    }
	},
	created : function(){
 		this.startChange();
 		this.endChange();
 	},
 	mounted : function(){
 	},
	methods: {
		startChange : function(){
    		if(!this.start){
 				this.date = [];
 				return;
 			}else{
 				this.date[0] = this.start.toDate("yyyy-MM-dd");
 			}
    	},
    	endChange : function(){
    		if(!this.end){
 				this.date = [];
 				return;
 			}else{
 				this.date[1] = this.end.toDate("yyyy-MM-dd");
 			}
    	}
  	},
 	watch : {
 		date : function(){
 			if(!this.date[0]){
 				this.$emit('update:start',null);
 				this.$emit('update:end',null);
 			}else{
 				this.$emit('update:start',this.date[0].format("yyyy-MM-dd"));
 				this.$emit('update:end',this.date[1].format("yyyy-MM-dd"));
 			}
 		},
 		start : function(newVal,oldVal){
 			this.startChange();
 		},
 		end : function(newVal,oldVal){
 			this.endChange();
 		}
 	}
}
</script>
